import { Component, OnInit, ViewChild, TemplateRef, OnDestroy } from '@angular/core';
import { LocalDataSource } from 'ng2-smart-table';
import { ManagementGroupsPermissionConfigService } from './shared/management-groups-permission.config.service';
import { Logger, AuthenticationService } from '@app/core';
import {
  BaseControl,
  ConfirmComponent,
  Const,
  Rol,
  Base,
  PermisoRol,
  PredeterminadoPermisoRol
} from '@app/shared';
import { ToastrService } from 'ngx-toastr';
import { GroupsPermissionsDataService } from '../shared/groups-permissions.data.service';
import { ManagementGroupsPermissionDataService } from './shared/management-groups-permission.data.service';
import { FormGroup, FormControl } from '@angular/forms';
import { ManagementGroupsPermissionFormsService } from './shared/management-groups-permission.form.service';
import { find } from 'lodash';
import { Subject } from 'rxjs';

const log = new Logger('ManagementGroupsPermissionComponent');

export interface RolDefaultPermissions {
  rol: number;
  permiso: Array<number>;
}

@Component({
  selector: 'iw-management-groups-permission',
  templateUrl: './management-groups-permission.component.html',
  styleUrls: ['./management-groups-permission.component.scss'],
  providers: [
    GroupsPermissionsDataService,
    ManagementGroupsPermissionDataService,
    ManagementGroupsPermissionFormsService
  ]
})
export class ManagementGroupsPermissionComponent implements OnInit, OnDestroy {

  // Define la accion a realizar en el formulario
  actionForm = '';
  // Pregunta de la modal de confirmaciones
  question = '';
  // Contiene el id del grupo seleccionado
  idGroupSelect = -1;
  // Contiene el id del tipo de permiso seleccionado
  idTypePermissionSelect: number = null;
  // Define cuando mostrar la tabla principal o el formulario
  formOpen = false;
  // Define los tipos de permisos que tiene el usuario en sesión
  activateAction = {
    created: false,
    review: false,
    delete: false,
  };
  // Configuracion de la tabla
  settings = {};
  // Datos para llenar la tabla
  sourceData: LocalDataSource;
  // Contiene el permiso seleccionado
  permissionSelect: PermisoRol;
  // Contiene los roles(Grupos) para listar en el select
  roles: Array<Rol> = [];
  // Contiene los tipos de permisos
  typesPermissions: Array<Base> = [];
  // Contiene los permisos
  permissions: Array<PredeterminadoPermisoRol> = [];
  // Contiene los controles de el formulario de asociaciones
  controls: BaseControl<any>[] = [];
  // Contiene los permisos del grupo seleccionado
  permissionsGroup: Array<PermisoRol>;
  // formulario de agregar permisos
  form: FormGroup = new FormGroup({
    cboGroup: new FormControl(null),
  });
  // Destruye y gestiona el memory leak
  private destroy: Subject<void> = new Subject<void>();
  // Referencia al componente de confirmación
  @ViewChild('confirm') private confirm: ConfirmComponent;
  // Referencia a la plantilla para el control personalizado de ng-select
  @ViewChild('ngSelect') ngSelectTpl: TemplateRef<any>;
  // Referencia a la plantilla para el control personalizado de ng-select
  @ViewChild('ngMultiSelect') ngMultiSelectSelectTpl: TemplateRef<any>;

  constructor(
    private gpds: GroupsPermissionsDataService,
    private mgpds: ManagementGroupsPermissionDataService,
    private mgpfs: ManagementGroupsPermissionFormsService,
    private as: AuthenticationService,
    private toastr: ToastrService,
  ) { }

  ngOnInit() {
    // determina los permisos del usuario en sesion
    this.activateAction.created = this.as.confirmPermission(
      Const.types_permissions.administrationGroupsPermissions,
      Const.types_action_permissions.created,
    );
    this.activateAction.review = this.as.confirmPermission(
      Const.types_permissions.administrationGroupsPermissions,
      Const.types_action_permissions.review,
    );
    this.activateAction.delete = this.as.confirmPermission(
      Const.types_permissions.administrationGroupsPermissions,
      Const.types_action_permissions.delete,
    );
    const configTable = new ManagementGroupsPermissionConfigService();
    this.settings = configTable.settings;
    configTable.accion.subscribe((res: any) => {
      log.debug(res.value, res.row);
      this.defineActionCondictions('delete', res.row);
    });
    this.gpds.getRoles().subscribe(roles => this.roles = roles);
    this.mgpds.getTypePermission().subscribe(typePermissions => {
      if (typePermissions.length) {
        typePermissions.forEach(typePermission => {
          typePermission.nombre = typePermission.nombre.replace(/\_/g, ' ');
          typePermission.nombre = typePermission.nombre.charAt(0).toUpperCase() + typePermission.nombre.slice(1);
        });
        typePermissions.sort((a, b) => {
          if (a.nombre > b.nombre) {
            return 1;
          }
          if (a.nombre < b.nombre) {
            return -1;
          }
          // a must be equal to b
          return 0;
        });
        this.typesPermissions = typePermissions;
      }
    });
    this.form.controls['cboGroup'].valueChanges.subscribe(data => this.selectRol(data));
  }

  ngOnDestroy() {
    this.destroy.next();
    this.destroy.complete();
  }

  /**
   * Controla las acciones a realizar con los permisos
   *
   * @param {('add' | 'update' | 'delete')} [action='add']
   * @param {*} [data]
   * @memberof ManagementGroupsPermissionComponent
   */
  defineActionCondictions(action: 'add' | 'update' | 'delete' = 'add', data?: any) {
    switch (action) {
      case 'add':
        if (this.activateAction.created) {
          this.formOpen = true;
          this.actionForm = 'Agregar';
          this.controls = this.mgpfs.getFormRol(
            {
              ngSelect: this.ngSelectTpl,
              ngMultiSelect: this.ngMultiSelectSelectTpl
            },
            {
              typesPermission: this.typesPermissions
            }
          );
        } else {
          this.toastr.error(
            'Usted no posee permisos para agregar permisos a los grupos del sistema',
            'Permiso denegado'
          );
        }
        break;
      case 'delete':
        if (this.activateAction.delete) {
          this.permissionSelect = data;
          this.question = '¿Realmente desea eliminar el permiso al grupo?';
          this.confirm.open();
        } else {
          this.toastr.error(
            'Usted no posee permisos para eliminar permisos a los grupos del sistema',
            'Permiso denegado'
          );
        }
        break;
    }
  }

  /**
   * Controla el evento de guardar en el formulario de asociar permisos a un rol(Grupo)
   *
   * @param {*} data
   * @memberof ManagementGroupsPermissionComponent
   */
  sended(data: any) {
    if (data) {
      let duplicatePermissions = false;
      if (data.cboPermiso && data.cboPermiso.length) {
        data.cboPermiso.forEach((el: number) => {
          const permissionSel = find(this.permissionsGroup, {id_permiso: el});
          if (permissionSel && !duplicatePermissions) {
            this.toastr.error(
              'El permiso ' + permissionSel.nombre + ' ya existe para el grupo seleccionado',
              'Error de operacion'
            );
            duplicatePermissions = true;
          }
        });
        if (!duplicatePermissions) {
          let permission: RolDefaultPermissions;
          permission = {
            rol: this.idGroupSelect,
            permiso: data.cboPermiso
          };
          this.mgpds.addPermission(permission).then(res => {
            if (res) {
              this.selectRol(this.idGroupSelect);
              this.closeFormRol();
            }
          }).catch(err => {
            log.debug(err);
          });
        }
      }
    }
  }

  /**
   * Cierra el formulario o reinicia el componete a la tabla principal
   *
   * @memberof ManagementGroupsPermissionComponent
   */
  closeFormRol() {
    this.actionForm = '';
    this.question = '';
    this.formOpen = false;
    this.permissionSelect = null;
    this.permissions = [];
    this.idTypePermissionSelect = null;
  }

  /**
   * Controla la respuesta del modal de confirmaciones
   *
   * @param {boolean} res
   * @memberof ManagementGroupsPermissionComponent
   */
  actionComfirm(res: boolean) {
    if (res) {
      this.deletePermission();
    }
    this.question = '';
  }

  /**
   * Controla el evento de seleccionar un rol(Grupo) en el select principal
   *
   * @param {*} data
   * @memberof ManagementGroupsPermissionComponent
   */
  selectRol(data: any) {
    if (this.activateAction.review) {
      if (data) {
        this.idGroupSelect = data;
        this.mgpds.getRolesPermission(this.idGroupSelect).subscribe(permissions => {
          if (permissions && permissions.permisos.length) {
            permissions.permisos.forEach(permission => {
              permission.nombre = permission.nombre.replace(/\_/g, ' ');
              permission.nombre = permission.nombre.charAt(0).toUpperCase() + permission.nombre.slice(1);
              permission.tipo_permiso = permission.tipo_permiso.replace(/\_/g, ' ');
              // tslint:disable-next-line:max-line-length
              permission.tipo_permiso = permission.tipo_permiso.charAt(0).toUpperCase() + permission.tipo_permiso.slice(1);
            });
            permissions.permisos.sort((a, b) => {
              if (a.tipo_permiso > b.tipo_permiso) {
                return 1;
              }
              if (a.tipo_permiso < b.tipo_permiso) {
                return -1;
              }
              // a must be equal to b
              return 0;
            });
          }
          this.permissionsGroup = permissions.permisos;
          this.sourceData = new LocalDataSource(permissions.permisos);
          this.sourceData.refresh();
        });
      } else {
        this.idGroupSelect = -1;
      }
    } else {
      this.toastr.error('Usted no posee permisos para ver los permisos de los grupos del sistema', 'Permiso denegado');
    }
  }

  /**
   * Controla el evento de cambios en el formulario de asociacion de permiso al rol(Grupo)
   *
   * @param {*} data
   * @memberof ManagementGroupsPermissionComponent
   */
  changeform (data: any) {
    if (data.change) {
      if (this.idTypePermissionSelect !== data.change.cboTypePermission) {
        this.idTypePermissionSelect = data.change.cboTypePermission;
        const permission: PermisoRol = {
          id: null,
          id_permiso: null,
          id_tipo_permiso: data.change.cboTypePermission,
          tipo_permiso: '',
          nombre: ''
        };
        this.loadingPermissionByType(permission);
      }
    }
  }

  /**
   * Carga los permisos por el tipo de permiso seleccionado
   *
   * @param {PermisoRol} data
   * @memberof ManagementGroupsPermissionComponent
   */
  loadingPermissionByType(data: PermisoRol) {
    this.permissions = [];
    if (this.idTypePermissionSelect) {
      this.mgpds.getPermissionByType(this.idTypePermissionSelect).subscribe(permission => {
        if (permission.permisos.length) {
          permission.permisos.forEach(typePermission => {
            typePermission.nombre = typePermission.nombre.replace(/\_/g, ' ');
            typePermission.nombre = typePermission.nombre.charAt(0).toUpperCase() + typePermission.nombre.slice(1);
          });
          permission.permisos.sort((a, b) => {
            if (a.nombre > b.nombre) {
              return 1;
            }
            if (a.nombre < b.nombre) {
              return -1;
            }
            // a must be equal to b
            return 0;
          });
          this.permissions = permission.permisos;
        }
        this.loadingFormPermission(data);
      });
    } else {
      this.loadingFormPermission(data);
    }
  }

  /**
   * Carga o refresca el formulario de asocciacion de permiso a rol(Grupo)
   *
   * @param {PermisoRol} [data]
   * @memberof ManagementGroupsPermissionComponent
   */
  loadingFormPermission(data?: PermisoRol) {
    this.controls = this.mgpfs.getFormRol(
      {
        ngSelect: this.ngSelectTpl,
        ngMultiSelect: this.ngMultiSelectSelectTpl
      },
      {
        typesPermission: this.typesPermissions,
        permission: this.permissions
      },
      data
    );
  }

  /**
   * Elimina un permiso de un rol(Grupo)
   *
   * @private
   * @memberof ManagementGroupsPermissionComponent
   */
  private deletePermission() {
    this.mgpds.deletePermission(this.idGroupSelect, [this.permissionSelect.id_permiso]).then(() => {
      this.selectRol(this.idGroupSelect);
      this.closeFormRol();
    }).catch(() => {
      this.closeFormRol();
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/administration/groups-permissions/management-groups-permission/management-groups-permission.component.ts